<template>
  <div id="user_form_box">
    <van-field
      :key="name"
      :name="name"
      v-model="userName"
      :label="nameText + '姓名'"
      placeholder="请输入"
      :rules="[{ required: true, message: '请输入姓名' }]"
    />
    <van-field
      :key="typeName"
      :name="typeName"
      :label="nameText + '证件类型'"
      :value="certificateType"
      :rules="[{ required: true, message: '请选择证件类型' }]"
    >
      <template #input>
        <select-popup
          v-model="certificateType"
          :columns="[
            { text: '身份证', value: '1' },
            { text: '护照', value: '2' },
            { text: '军官证', value: '3' },
            { text: '警官证', value: '4' },
            { text: '士兵证', value: '5' },
            { text: '台湾居民来往大陆通行证', value: '6' },
            { text: '回乡证', value: '7' },
            { text: '港澳居民来往内地通行证', value: '8' },
            { text: '港澳台居民居住证', value: '10' },
            { text: '营业执照', value: '11' },
            { text: '组织机构代码证', value: '12' },
            { text: '税务登记证', value: '13' },
            { text: '商业登记证', value: '14' },
            { text: '民办非企业登记证书', value: '15' },
            { text: '批文证明', value: '16' },
          ]"
        />
      </template>
    </van-field>
    <van-field
      :key="codeName"
      :name="codeName"
      v-model="certificateCode"
      :label="nameText + '证件号'"
      placeholder="请输入"
      :rules="[{ required: true, message: '请输入证件号' }]"
    />
    <van-field
      label-width="140px"
      :key="beginTimeName"
      :name="beginTimeName"
      :label="nameText + '证件开始日期'"
      :value="certificateValidityBegin"
    >
      <template #input>
        <van-cell
          class="date_cell"
          is-link
          @click="beginDatePickerShow = true"
          :value="certificateValidityBegin"
        />
      </template>
    </van-field>
    <van-popup v-model="beginDatePickerShow" position="bottom" round>
      <van-datetime-picker
        type="date"
        :value="certificateValidityBegin"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="beginDateConfirm"
        @cancel="beginDatePickerShow = false"
      />
    </van-popup>
    <van-field
      label-width="140px"
      :key="endTimeName"
      :name="endTimeName"
      :label="nameText + '证件截止日期'"
      :value="certificateValidityEnd"
    >
      <template #input>
        <van-cell
          class="date_cell"
          is-link
          @click="endDatePickerShow = true"
          :value="certificateValidityText"
        />
      </template>
    </van-field>
    <van-popup v-model="endDatePickerShow" position="bottom" round>
      <van-datetime-picker
        type="date"
        :value="certificateValidityEnd"
        :min-date="minDate"
        :max-date="maxDate"
        :readonly="is_valid"
        @confirm="endDateConfirm"
        @cancel="endDatePickerShow = false"
      />
      <van-checkbox
        class="date_popup_check"
        v-model="is_valid"
        shape="square"
        icon-size="14px"
      >
        长期有效
      </van-checkbox>
    </van-popup>
    <template v-if="nameText === '受益人'">
      <van-field
        key="bnf_up"
        name="bnf_up"
        :label="nameText + '证件正面照片'"
        :rules="[{ validator: uploadValidator, message: '请上传' }]"
      >
        <template #input>
          <CellUpload
            name="受益人证件正面照"
            type="0042"
            text="证件正面照片"
            v-model="bnfUP"
          />
        </template>
      </van-field>
      <van-field
        key="bnf_down"
        name="bnf_down"
        :label="nameText + '证件反面照片'"
        :rules="[{ validator: uploadValidator, message: '请上传' }]"
      >
        <template #input>
          <CellUpload
            name="受益人证件反面照"
            type="0043"
            text="证件反面照片"
            v-model="bnfDown"
          />
        </template>
      </van-field>
      <van-field
        v-for="(item, index) in pic_list"
        :key="item.file_path || index"
        :name="'bnfPicList' + (index + 1)"
        :label="'证明材料' + (index + 1)"
      >
        <template #input>
          <CellUpload
            type="0041"
            :name="'受益人证明材料' + (index + 1)"
            :text="'证明材料' + (index + 1)"
            v-model="pic_list[index]"
          />
        </template>
        <template #extra>
          <div>
            <span
              v-if="pic_list.length === index + 1"
              class="add_btn"
              @click="addPic()"
              >增加</span
            >
            <span
              v-if="pic_list.length !== index + 1"
              class="del_btn"
              @click="delPic(index)"
              >删除</span
            >
          </div>
        </template>
      </van-field>
      <van-field
        :key="sexName"
        :name="sexName"
        :label="nameText + '性别'"
        :value="sex"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <template #input>
          <select-popup
            v-model="sex"
            :columns="[
              { text: '男', value: '1' },
              { text: '女', value: '2' },
            ]"
          />
        </template>
      </van-field>
      <van-field
        label-width="140px"
        :key="birthdayName"
        :name="birthdayName"
        :label="nameText + '出生日期'"
        :value="birthday"
      >
        <template #input>
          <van-cell
            class="date_cell"
            is-link
            @click="birthdayPickerShow = true"
            :value="birthday"
          />
        </template>
      </van-field>
      <van-popup v-model="birthdayPickerShow" position="bottom" round>
        <van-datetime-picker
          type="date"
          :value="birthday"
          :min-date="minDate"
          @confirm="birthdayConfirm"
          @cancel="birthdayPickerShow = false"
        />
      </van-popup>
      <van-field
        :key="phoneName"
        :name="phoneName"
        v-model="phone"
        :label="nameText + '手机号'"
        placeholder="请输入"
        :rules="[
          { required: true, message: '请输入手机号' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号格式错误',
            trigger: 'onBlur',
          },
        ]"
      />
      <van-field
        :key="nationName"
        :name="nationName"
        :label="nameText + '国籍'"
        :value="nation"
        :rules="[{ required: true, message: '请选择国籍' }]"
      >
        <template #input>
          <select-popup v-model="nation" :columns="nationList" />
        </template>
      </van-field>
      <van-field
        :key="natrlName"
        :name="natrlName"
        :label="nameText + '是否为特定自然人'"
        :value="natrl"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <template #input>
          <select-popup
            v-model="natrl"
            :columns="[
              { text: '是', value: '1' },
              { text: '否', value: '0' },
            ]"
          />
        </template>
      </van-field>
    </template>
    <van-field
      :key="addrName"
      :name="addrName"
      v-model="address"
      :label="nameText + '家庭地址'"
      placeholder="请输入"
      :rules="[{ required: true, message: '请输入家庭地址' }]"
    />
  </div>
</template>

<script>
import SelectPopup from "./SelectPopup";
import CellUpload from "./CellUpload";
export default {
  components: {
    SelectPopup,
    CellUpload,
  },
  props: [
    "nameText",
    "name",
    "phoneName",
    "typeName",
    "codeName",
    "beginTimeName",
    "endTimeName",
    "addrName",
    "formObj",
    "sexName",
    "birthdayName",
    "nationName",
    "natrlName",
  ],
  data() {
    return {
      userName: "",
      phone: "",
      sex: "",
      birthday: "",
      birthdayPickerShow: false,
      nation: "",
      natrl: "",
      bnfUP: {},
      bnfDown: {},
      pic_list: [{}],
      certificateType: "",
      certificateCode: "",
      certificateValidityBegin: "",
      certificateValidityEnd: "",
      address: "",
      beginDatePickerShow: false,
      endDatePickerShow: false,
      minDate: new Date(1970, 1, 1),
      maxDate: new Date(),
      is_valid: false,
      nationList: [],
    };
  },
  created() {
    this.getNationList();
    this.maxDate = new Date(new Date().getFullYear() + 30, 11, 31);
  },
  computed: {
    certificateValidityText() {
      return this.certificateValidityEnd === "9999-12-31"
        ? "长期有效"
        : this.certificateValidityEnd;
    },
  },
  watch: {
    formObj: {
      handler(newV, oldV) {
        let userFormObj = {};
        if (this.nameText === "控股股东") {
          userFormObj = newV.commitData.complexUploadBasic;
        } else if (this.nameText === "受益人") {
          userFormObj = newV.commitData.complexUploadBasic.bnfList[0];
          this.phone = userFormObj[this.phoneName];
          this.sex = userFormObj[this.sexName];
          this.birthday = userFormObj[this.birthdayName];
          this.nation = userFormObj[this.nationName];
          this.natrl = userFormObj[this.natrlName];
        }
        this.userName = userFormObj[this.name];
        this.certificateType = userFormObj[this.typeName];
        this.certificateCode = userFormObj[this.codeName];
        this.certificateValidityBegin = userFormObj[this.beginTimeName];
        this.certificateValidityEnd = userFormObj[this.endTimeName];
        this.address = userFormObj[this.addrName];
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    addPic() {
      this.pic_list.push({});
    },
    delPic(index) {
      this.pic_list.splice(index, 1);
    },
    uploadValidator(value, rule) {
      return value[0].file_path && value[0].file_path !== "" ? true : false;
    },
    async getNationList() {
      const res = await this.$apis.zzsignServe.getNation();
      this.nationList = res.data.map((item) => ({
        text: item.name,
        value: item.code,
      }));
    },
    beginDateConfirm(query) {
      this.certificateValidityBegin = this.$global.transferDay(query);
      this.beginDatePickerShow = false;
    },
    birthdayConfirm(query) {
      this.birthday = this.$global.transferDay(query);
      this.birthdayPickerShow = false;
    },
    endDateConfirm(query) {
      this.certificateValidityEnd = this.is_valid
        ? "9999-12-31"
        : this.$global.transferDay(query);
      this.endDatePickerShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
#user_form_box {
  .date_cell {
    padding: 0;
    border: none;

    &::v-deep .van-cell__value {
      text-align: right;
    }
  }
}
.date_popup_check {
  margin: 22px 0;
  justify-content: center;
}
.add_btn {
  margin-left: 10px;
  color: #4a79f1;
}
.del_btn {
  margin-left: 10px;
  color: red;
}
</style>
